module.exports = __webpack_public_path__ + "img/42.b42af8e0.jpg";